import { defineMessages } from 'react-intl';

const messages = defineMessages({
  licensingAuthorityTitle: {
    defaultMessage: 'Licensing authority',
    id: 'KgwE9+',
    description: 'Licensing authority field title',
  },
  licensingAuthorityDescription: {
    defaultMessage: 'Same as the chauffeur’s licensing authority.',
    id: 'af06K1',
    description: 'Licensing authority field description',
  },
  phvTitle: {
    defaultMessage: 'Private Hire Vehicle License Number',
    id: 'FYXoly',
    description: 'PHV License Number field title',
  },
  phvDescription: {
    defaultMessage: 'Full PHV licence number including all digits.',
    id: 'b84gsv',
    description: 'Vehicle form - PHV field description',
  },
  phvInvalid: {
    defaultMessage: 'Invalid PHV.',
    id: '2LPalV',
    description: 'Validation message',
  },
});

export { messages };
